import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CommonDocumentFilterModel, CommonDocumentFilterWithPage, Page} from '../components/common-interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuditLogsService {

  constructor(private httpClient: HttpClient) {
  }

  getAuditLogs(auditLogType: AuditLogType, filter: AuditLogFilter): Observable<Page<AuditLog>> {
    return this.httpClient.post<Page<AuditLog>>(`${environment.apiSegments}/${auditLogType}/audit-logs`, filter);
  }

  getSegmentAuditLogs(id: number): Observable<SegmentAuditLog[]> {
    return this.httpClient.get<SegmentAuditLog[]>(`${environment.apiSegments}/segments/${id}/audit-logs`);
  }
}

export enum AuditLogType {
  SEGMENT = 'SEGMENT',
  TTD_CATEGORY = 'TTD_CATEGORY'
}

export interface AuditLog {
  id: string;
  request: any;
  performedBy?: string;
  performedAt: Date;
}

export interface AuditLogFilter extends CommonDocumentFilterWithPage {
  search?: string;
}

export interface AuditLogSearchFilterModel extends CommonDocumentFilterModel {
  search?: string;
}

export interface TtdCategoryAuditLog extends AuditLog {
  type: TtdCategoryAuditLogType;
  categoryId: number;
}

export enum TtdCategoryAuditLogType {
  CREATE = 'CREATE',
  ADD_PRICE = 'ADD_PRICE',
  ADD_GROUP_PRICE = 'ADD_GROUP_PRICE',
  UPDATE_PRICE = 'UPDATE_PRICE',
  UPDATE_GROUP_PRICE = 'UPDATE_GROUP_PRICE'
}

export interface SegmentAuditLog extends AuditLog {
  type: SegmentAuditLogType;
  segmentId: number;
  foreignAccountId: string;
}

export enum SegmentAuditLogType {
  ADD_PRICING = 'ADD_PRICING',
  UPDATE_PRICING = 'UPDATE_PRICING',
  DELETE_MAPPING = 'DELETE_MAPPING',
  CREATE_VALIDATION = 'CREATE_VALIDATION',
  UPDATE_VALIDATION = 'UPDATE_VALIDATION',
  DELETE_VALIDATION = 'DELETE_VALIDATION',
  CREATE_SEGMENT_BILLING = 'CREATE_SEGMENT_BILLING',
  UPDATE_SEGMENT_BILLING = 'UPDATE_SEGMENT_BILLING',
  DELETE_SEGMENT_BILLING = 'DELETE_SEGMENT_BILLING',
  CREATE_BUYER_SEGMENT_SHARING = 'CREATE_BUYER_SEGMENT_SHARING',
  UPDATE_BUYER_SEGMENT_SHARING = 'UPDATE_BUYER_SEGMENT_SHARING',
  REMOVE_SEGMENT_FROM_BUYER = 'REMOVE_SEGMENT_FROM_BUYER',
  UPDATE_SEGMENT_STATUS = 'UPDATE_SEGMENT_STATUS',
  SHARE = 'SHARE',
  CREATE_MAPPING = 'CREATE_MAPPING',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE'
}

export interface AuditLogsListConfig {
  auditLogType: AuditLogType;
  defaultFilterValues: AuditLogSearchFilterModel;
  columnsToDisplay: string[];
  searchInputPlaceholder: string;
}

export const SegmentAuditLogsListConfig: AuditLogsListConfig = {
  auditLogType: AuditLogType.SEGMENT,
  defaultFilterValues: {
    search: '',
    performedBy: '',
    dateFrom: undefined,
    dateTo: undefined
  },
  columnsToDisplay: ['segmentId', 'foreignAccountId', 'type', 'performedBy', 'performedAt'],
  searchInputPlaceholder: 'Segment Id, Foreign Account Id, Type'
};

export const TtdCategoryAuditLogsListConfig: AuditLogsListConfig = {
  auditLogType: AuditLogType.TTD_CATEGORY,
  defaultFilterValues: {
    search: '',
    performedBy: '',
    dateFrom: undefined,
    dateTo: undefined
  },
  columnsToDisplay: ['categoryId', 'type', 'performedBy', 'performedAt'],
  searchInputPlaceholder: 'Category Id, Type'
};


